import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../../store';
import { VISUALIZER_SHAPE } from '../../../../Preview/PreviewDisplayConstants';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import VisualizerSpinSpeedListItem from './VisualizerSpinSpeedListItem';
import VisualizerSpinLockLogoListItem from './VisualizerSpinLockLogoListItem';
import VisualizerSpinAccelerationListItem from './VisualizerSpinAccelerationListItem';

const VisualizerSpinListItem = ({ enabled, visualizerShape, updateVisualizerSettings }) => {
    const onStateChange = (value) => {
        updateVisualizerSettings({
            spinSettings: { enabled: value }
        });
    };

    // Spin is not applicable to the flat visualizer shape.
    if (visualizerShape === VISUALIZER_SHAPE.FLAT)
        return null;

    return (
        <CollapsibleSwitchListItem
            checked={enabled}
            text='Spin'
            onChange={onStateChange}
            dense={false}
        >
            <List dense disablePadding>
                <VisualizerSpinSpeedListItem />

                <VisualizerSpinAccelerationListItem />

                <VisualizerSpinLockLogoListItem />
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state) => {
    const { spinSettings, shape: visualizerShape } = state.createPreview.present.videoSettings.visualizer;
    return { enabled: spinSettings.enabled, visualizerShape };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerSpinListItem);